import React from 'react';

const NotFoundPage = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '10%' }}>
    <a>
      <img
        src="/Images/Ishtar/IshtarNeutral.png"
        alt="Bot Avatar"
        style={{
          width: '350px',
          height: '350px',
          borderRadius: '50%',
        }}
      />
    </a>
    <h1 style={{ fontSize: '24px', margin: '10px 0' }}>404 Not Found</h1>
    <p style={{ fontSize: '16px', color: 'gray' }}>
      The page you're looking for doesn't exist.
    </p>
  </div>
  );
};

export default NotFoundPage;
